import { Select, SelectProps, SelectSize } from "@justhome/react-ui";
import {
  Control,
  FieldPath,
  FieldValues,
  UseControllerProps,
  useController,
} from "react-hook-form";

interface ControlledSelectProps<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
> extends Omit<SelectProps<TFieldValues[TName]>, "children"> {
  name: TName;
  control: Control<TFieldValues>;
  options: any[];
  size?: SelectSize;
  rules?: UseControllerProps<TFieldValues>["rules"];
  defaultValue?: TFieldValues[TName];
}

const ControlledSelect = <
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
>({
  options,
  control,
  name,
  size = "md",
  rules,
  defaultValue,
  ...props
}: ControlledSelectProps<TFieldValues, TName>) => {
  const { field, fieldState } = useController({
    rules,
    name,
    control,
    defaultValue,
  });

  return (
    <Select
      {...field}
      {...props}
      size={size}
      errorMessage={fieldState.error?.message}
    >
      {options
        .filter(
          (option) =>
            !option.hidden || (option.hidden && option.value === field.value),
        )
        .map((option) => (
          <Select.Option key={option.label} value={option.value}>
            {option.label}
          </Select.Option>
        ))}
    </Select>
  );
};

export default ControlledSelect;
